<template>
  <VisaForm country="vietnam" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <EntryFields v-model="form.entry" has-port />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <PassportDetailsNotes />
      <AppRow>
        <HotelField v-model="form.hotel" />
      </AppRow>
      <EmergencyContactFields v-model="form.emergencyContact" has-address has-relation />
      <LazyApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
        </template>
        <template #personal>
          <ExtraNationalityFields v-model="applicant.extraNationality" />
          <AppRow>
            <IdNumberField v-model="applicant.idNumber" />
            <ReligionSelect v-model="applicant.religion" />
          </AppRow>
          <AddressFields v-model="applicant.address" />
          <OccupationFields v-model="applicant.occupation" has-phone has-address />
        </template>
      </LazyApplicantInfo>
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>